import { useState } from "react";
import {
  useSetBadgePinMutation,
  useSetOTPPinMutation,
} from "../services/idp/idp";
import { formatMessageFromResponseErrorData } from "../utils/errors";

type PinMutationHook =
  | typeof useSetOTPPinMutation
  | typeof useSetBadgePinMutation;

const usePinSetter = (usePinMutationHook: PinMutationHook) => {
  const [pinError, setPinError] = useState("");
  const [registration, regState] = usePinMutationHook();

  const setPin = async (pin: string): Promise<boolean> => {
    setPinError("");
    try {
      await registration({ pin }).unwrap();
      return true;
    } catch (error) {
      console.error({ error });
      const data =
        typeof error === "object" && error !== null && "data" in error
          ? (error as { data: unknown }).data
          : undefined;
      setPinError(formatMessageFromResponseErrorData(data));
      return false;
    }
  };

  return {
    setPin,
    pinError,
    isPinError: regState.isError,
    isPinSuccess: regState.isSuccess,
    isPinLoading: regState.isLoading,
  };
};

export const useSetOTPPin = () => usePinSetter(useSetOTPPinMutation);
export const useSetBadgePin = () => usePinSetter(useSetBadgePinMutation);
